module.exports = __webpack_public_path__ + "static/media/AH.aa274dd3.svg";